<template>
  <a-modal title="插入页面链接" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <a-form-model :model="form" class="container-ant" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="跳转名称" prop="title">
        <a-input v-model="form.title" style="width:300px" placeholder="请输入跳转名称" />
      </a-form-model-item>
      <a-form-model-item label="跳转链接" prop="path">
        <a-input v-model="form.path" style="width:300px" placeholder="请输入小程序页面链接" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields()
        })
      }
    }
  },
  methods: {
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.$emit('ok', this.form)
        }
      })
    },
    handleCancel() {
      this.$emit('cancel')
    }
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      photoSize: {
        width: '100px',
        height: '100px'
      },
      form: {
        title: '',
        path: ''
      },
      rules: {
        title: [{ required: true, message: '请输入跳转名称', trigger: ['blur', 'change'] }],
        path: [{ required: true, message: '请输入链接', trigger: ['blur', 'change'] }]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.image-tips {
  position: absolute;
  right: -2px;
  top: 0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  line-height: initial;
}
/deep/.imgupload .updata__operation {
  margin: 0 20px 0px 0;
}
</style>
